import { render, staticRenderFns } from "./CategoriaClienteEdit.vue?vue&type=template&id=83771cbe&scoped=true&"
import script from "./CategoriaClienteEdit.vue?vue&type=script&lang=js&"
export * from "./CategoriaClienteEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83771cbe",
  null
  
)

export default component.exports